import React from 'react';

type GeoHubLocalNoteProps = {
    cityName: string;
};

const GeoHubLocalNote: React.FC<GeoHubLocalNoteProps> = ({cityName}) => {
    return (
        <p className="geo-hub-local-note">
            This list is built from places <strong>local foodies in {cityName}</strong> eat and share on
            Solt — not traveler picks, and not sponsored.
        </p>
    );
};

export default GeoHubLocalNote;
